import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { TokenDataService } from "app/shared/services/token-data.service";
import { JwtAuthService } from "../services/jwt-auth.service";
import * as operacije from "../../shared/constants/operacije.enum";

@Injectable()
export class AdministratorMetaregistraGuard implements CanActivate {

  constructor(
    private jwtAuth: JwtAuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.jwtAuth.korisnikImaOperacijuGlobalno(operacije.OperacijeEnum.OP_RP_ADMINISTRIRANJE);
  }
}
